import { providesList } from '@helpers/index';
import BaseService from '../base';
import {
  AreaSectionApiProps,
  AreaSectionFilterProps,
  EmployersApiProps,
  FacilitiesApiProps,
  JobTypeApiProps,
  ModuleParams,
  ModulesApiProps,
  ReportApiProps,
  SectionsApiProps,
  SiteChildsApiProps,
} from './types';

class Site extends BaseService {
  getEmployers() {
    return {
      query: (siteId: number) => `${this.url}/${siteId}/employers`,
      providesTags: (result: EmployersApiProps | undefined) => providesList(result, this.tagType),
    };
  }

  getFacilities() {
    return {
      query: (siteId: number) => `${this.url}/${siteId}/facilities`,
      providesTags: (result: FacilitiesApiProps | undefined) => providesList(result, this.tagType),
    };
  }

  getDumpAreaSectionsBySite() {
    return {
      query: (siteId: number) => `${this.url}/${siteId}/area-sections?category=area&dump=true`,
      providesTags: (result?: SectionsApiProps) => providesList(result, this.tagType),
    };
  }

  getAreaSectionsBySite() {
    return {
      query: ({ siteId, ...params }: AreaSectionFilterProps) => ({
        url: `${this.url}/${siteId}/sections?category=area`,
        params,
      }),
      // eslint-disable-next-line max-len
      providesTags: (result: AreaSectionApiProps | undefined) => providesList(result?.sections, this.tagType),
    };
  }

  getSiteChilds() {
    return {
      query: (siteId: number) => ({
        url: `${this.url}/${siteId}/childs`,
      }),
      // eslint-disable-next-line max-len
      providesTags: (result: SiteChildsApiProps | undefined) => providesList(result, this.tagType),
    };
  }

  getModules() {
    return {
      query: ({ id, ...params }: ModuleParams) => ({
        url: `${this.url}/${id}/modules`,
        params,
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result: ModulesApiProps[] | undefined) => [{ type: this.tagType }],
    };
  }

  updateModules() {
    return {
      query: ({ id, ...params }: ModuleParams) => ({
        url: `${this.url}/${id}/modules/${params.name}`,
        body: params,
        method: 'PATCH',
      }),
      invalidatesTags: [{ type: this.tagType }],
    };
  }

  getSiteReports() {
    return {
      query: (id: number) => ({
        url: `${this.url}/${id}/reports`,
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result: ReportApiProps[] | undefined) => [{ type: this.tagType }],
    };
  }

  getJobTypes() {
    return {
      query: (id: number) => ({
        url: 'job_types',
        params: { site_id: id },
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result: JobTypeApiProps | undefined) => [{ type: this.tagType }],
    };
  }
}

export default new Site('sites', 'Site');
